import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Company, CompaniesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CompaniesDataService {

  private uri: string = `${environment.apiUrl}companies`;
  private cacheKey: string = 'companies.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getCompany(id: number): Observable<Company|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getCompanies(parameters: {[param: string]: string | string[]}): Observable<CompaniesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addCompany(data: Company): Observable<Company|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addCompanies(data: Company[]): Observable<Company[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateCompany(data: Company): Observable<Company|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateCompanies(data: Company[]): Observable<Company[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchCompany(data: Company): Observable<Company|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchCompanies(data: Company[]): Observable<Company[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteCompany(data: Company): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteCompanies(data: Company[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((company) => {
      ids.push(company.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
